import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {
  SLAReportDownloadDropdown,
  SLAReportDownloadDropdownProps,
} from "@/pages/reports/sla/details/actions/SLAReportDownloadDropdown.tsx";
import {SLAReportEditButton} from "@/pages/reports/sla/details/actions/SLAReportEditButton.tsx";

export const SLAReportActionBar = ({id, start, end, query, hasGroups}: SLAReportDownloadDropdownProps) => {
  const {user} = useCurrentUserContext();
  return (
    <div className="d-flex align-content-center">
      {user?.has_write_access && <SLAReportEditButton id={id} className="me-2" />}
      <SLAReportDownloadDropdown id={id} start={start} end={end} query={query} hasGroups={hasGroups} />
    </div>
  );
};
